package pl.zar.tikthrow.ui.media

import androidx.compose.runtime.Composable
import kotlinx.serialization.Serializable
import pl.zar.tikthrow.viewmodel.ContentType

@Serializable
data class MediaItem(
    val uri: String,
    val isVideo: Boolean = false,
    val fileName: String? = null,
    val mimeType: String? = null,
    val fileSizeBytes: Long? = null
)

class MediaPickerState(
    val selectedMedia: List<MediaItem>,
    val launch: () -> Unit
)

@Composable
expect fun rememberMediaPickerState(
    contentType: ContentType? = null,
    onSelected: (List<MediaItem>) -> Unit
): MediaPickerState
